import React, { useEffect, useContext } from "react";
import { Button } from "../styles/styles";
import AppContext from "../context/context";
import work from "../assets/images/work.webp";
import darkIcon from "../assets/images/icons/dark right icon.webp";
import "../styles/error.scss";
import { Link } from "react-router-dom";
function Error() {
  const { setTopOn } = useContext(AppContext);
  useEffect(() => {
    setTopOn(true);
  }, [setTopOn]);
  const phSize = window.matchMedia("(max-width: 780px)").matches;
  return (
    <div className="error-con">
      <img src={work} alt="work" className="emoji" />
      <div className="text-hol">
        <h1>{`Oops${!phSize ? ", Almost done" : ""}!`}</h1>
        <p>
          This project's information is all-over-the-place.
          <br /> I am working hard to present it beutifully and will update it
          soon
        </p>
      </div>
      <div className="btn-group">
        <a
          href="https://www.behance.net/kola_abr"
          target="_blank"
          rel="noopener noreferrer"
          className="be"
        >
          {" "}
          <Button className="btn">
            {`${phSize ? "" : "Checkout"}`} My<span>Behance</span>
          </Button>
        </a>
        <Link to="/">
          <Button className=" btn btn-fill">
            Back to Home <img src={darkIcon} alt="icon" />
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default Error;
